// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__dFflA","author":"Table_author__14Inb","authorImage":"Table_authorImage__1keH5","unreadRow":"Table_unreadRow__130EK"};